module.exports = __webpack_public_path__ + "static/media/400108_01.2143305d.png";